export default ":host {\n  display: block;\n  min-width: 100px;\n  min-height: 100px;\n}\n"